import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import './App.css';
import AccountOverview from "./pages/AccountOverview";
import SignIn from "./pages/SignIn";
import Transaction from "./pages/Transaction";
import TransactionCheck from "./pages/TransactionCheck";
import { useCookies } from "react-cookie";
import ProtectedLayout from "./components/ProtectedLayout";
import AppTheme from "./mui-theme/AppTheme";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';

// Consolidate theme components here to be passed to the theme provider
const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

// A wrapper component to apply the theme to all protected routes
const ThemedProtectedLayout = () => (
    <AppTheme themeComponents={xThemeComponents}>
        <ProtectedLayout />
    </AppTheme>
);

function App() {
    const [cookies] = useCookies(['session-token']);
    const isLoggedIn = cookies['session-token'] && cookies['session-token'].length > 0;

    return (
        <>
            <Routes>
                {/* Public Route */}
                <Route
                    path="/sign-in"
                    element={isLoggedIn ? <Navigate to="/" replace /> : <SignIn />}
                />

                {/* Protected Routes */}
                <Route
                    path="/*"
                    element={isLoggedIn ? <ProtectedRoutes /> : <Navigate to="/sign-in" replace />}
                />
            </Routes>
        </>
    );
}

// A new component to structure the protected part of the app
function ProtectedRoutes() {
    return (
        <Routes>
            <Route element={<ThemedProtectedLayout />}>
                <Route path="/" element={<AccountOverview />} />
                <Route path="/transaction" element={<Transaction />} />
                <Route path="/transaction/check" element={<TransactionCheck />} />
                {/* Any other protected routes can be added here */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
        </Routes>
    );
}

export default App;
